import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
const CardWrapper = styled(motion.div)`
  position: relative;
  width: 400px;
  height: 384px;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;

  @media (max-width: 800px) {
    width: 100vw;
    height: 100vw;
  }
`

const CardBackground = styled.div`
  position: absolute;
  inset: 0;
  background-color: #000;
`



const ContentWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  color: white;
`

const Price = styled(motion.div)`
  font-size: 1.5rem;
  font-weight: bold;
`

const HoverContent = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`

const Description = styled.p`
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
`

const FeatureList = styled.ul`
  font-size: 0.875rem;
  list-style-type: disc;
  list-style-position: inside;
  margin-bottom: 1rem;
`

const BuyButton = styled(motion.button)`
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: #F0F0EC;
  border-radius: 0.375rem;
  color: #000;
  font-size: 0.875rem;
  font-weight: 600;
`

export default function BikeCard({ producto, type, formatoCOP }) {
  const [isHovered, setIsHovered] = useState(false)
  const images = producto?.inventories?.map(inv => inv.images)?.find(inv => inv.is_main == 1 || true || "1") 
  || producto?.inventories?.map(inv => inv.images)[0] || []
  const [isMobile, setIsMobile] = useState(window.innerWidth < 830);
  const navigate = useNavigate()
  const { ref, inView } = useInView({
    threshold: 0.5, 
     });
    


    useEffect(() => {
      if (isMobile && inView){
        setIsHovered(true)
      } 
      else if (isMobile && !inView){
        setIsHovered(false)
      }
    }, [inView])

  const BikeImage = styled(motion.div)`
  position: absolute;
  inset: 0;
  background-image: url(${images[0]?.pathname});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`
  return (
      <CardWrapper
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
        // onTouchEnd={() => setIsHovered(false)}
        ref={ref}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.3 }}
        onClick={() => navigate(`/producto/${type}/${producto?.slug}`)}
      >
        <CardBackground />
        <BikeImage
          animate={{
            scale: isHovered ? 1.1 : 1,
            filter: isHovered ? 'brightness(0.8)' : 'brightness(1)'
          }}
          transition={{ duration: 0.3 }}
        />
        <ContentWrapper>
          <Price
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
          >
           {formatoCOP.format(producto?.price)}
          </Price>
          <HoverContent 
            initial={{ opacity: 0 }}
            animate={{ opacity: isHovered ? 1 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <Title>{producto?.name}</Title>
            <FeatureList>
              <li>{producto?.details?.peso}</li>
            </FeatureList>
            <BuyButton
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate(`/producto/${type}/${producto?.slug}`)}
            >
              Ver más
            </BuyButton>
          </HoverContent>
        </ContentWrapper>
      </CardWrapper>
  )
}

